import { setGlobalState } from '@libs/client'
import { initRDT } from '@libs/client/hooks/useGlobalState/ReduxDevTool'
import { getLocalState, syncLocalTab } from '@libs/client/hooks/useGlobalState/StateLocal'

export function initializeClientState() {
  const INIT_STATE = {
    ...getLocalState()
  }
  setGlobalState(INIT_STATE, true)
  initRDT(INIT_STATE)
  // Set to false to avoid clearing state, this should be changed once we apply sync between tabs of browser.
  syncLocalTab((data: any) => setGlobalState(data))
}
